module.exports = __webpack_public_path__ + "static/media/soure-5.fa6a3b63.jpg";